var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"about-box",attrs:{"id":"about"}},_vm._l((_vm.imglist),function(item,index){return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item),expression:"item"}],key:index,attrs:{"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }